import { View } from 'es6/components/view'
import { Popup } from 'es6/libs/popup'
import { getCookie, setCookie } from 'helpers/cookie-helper'
import { getTemplate } from 'helpers/template-helper'
import { getDomain } from 'helpers/url-helpers'
import { Defaults } from 'es-decorators'

/**
 * Всплывающее окно рекомендации установки нового браузера
 */

@Defaults({
  el: '.old-browser-popup',
  additionalOptions: ['versions', 'bowser', 'operaMiniOrMobileOptions', 'isPageSpeedTest'],
  events: {
    'click .js-old-browser-popup-close': 'close',
  },
  isPageSpeedTest: false,
})
export class OldBrowserPopupView extends View {
  /**
   * @inheritDoc
   */
  run () {
    let isUnsupported = this.bowser.isUnsupportedBrowser(this.versions),
      isCookie = getCookie('is_popup_old_browser_closed') === 1
    if (this.operaMiniOrMobileOptions && this.operaMiniOrMobileOptions.name) {
      this.bowser.name = this.operaMiniOrMobileOptions.name
      isUnsupported = this.operaMiniOrMobileOptions.isUnsupported
    }
    if (isUnsupported && !isCookie && !this.isPageSpeedTest) {
      switch (this.bowser.name) {
        case 'Chrome':
          this.renderFoundPopup('https://www.google.ru/chrome/browser/', 'Google Chrome')
          break
        case 'Yandex Browser':
          this.renderFoundPopup('https://browser.yandex.ru/", "Яндекс Браузер')
          break
        case 'Microsoft Edge':
          this.renderFoundPopup('https://www.microsoft.com/ru-ru/windows/microsoft-edge', 'Microsoft Edge')
          break
        case 'Firefox':
          this.renderFoundPopup('https://www.mozilla.org/ru/firefox/new/', 'Mozilla Firefox')
          break
        case 'Opera':
          this.renderFoundPopup('http://www.opera.com/ru/', 'Opera')
          break
        case 'operamini':
          this.renderFoundPopup('http://www.opera.com/ru/mobile/mini', 'Opera Mini')
          break
        case 'operamobi':
          this.renderFoundPopup(' http://www.opera.com/ru/mobile', 'Opera Mobile')
          break
        default:
          this.renderDefaultPopup()
          break
      }
      this.popup = new Popup(this.$el)
      this.show()
    }
  }

  /**
   * Отобразить информацию для обновления текущего браузера пользователя
   * @param {string} link - ссылка на новый браузер
   * @param {string} name - название браузера
   */
  renderFoundPopup (link, name) {
    this.template = getTemplate('#old-browser-popup-found')
    this.$('.old-browser-content').html(this.template({
      browserName: name,
      browserLink: link,
    }))
  }

  /**
   * Вывод стандартного сообщения о смене браузера, если не поддерживается.
   */
  renderDefaultPopup () {
    this.template = getTemplate('#old-browser-popup-default')
    this.$('.old-browser-content').html(this.template())
  }

  /**
   * Показать попап.
   */
  show () {
    this.popup.open()
  }

  /**
   * Скрыть попап.
   */
  close () {
    this.saveCookie()
    this.popup.close()
  }

  /**
   * Установка куки на скрытие отображения браузера на 30 дней
   */
  saveCookie () {
    setCookie(
      'is_popup_old_browser_closed',
      1,
      {
        domain: `.${getDomain()}`,
        path: '/',
        expires: 30 * 24 * 3600,
      },
    )
  }
}
